import { ChangeDetectionStrategy, Component, computed, inject, viewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { filter } from 'rxjs/operators';

import { FORM_SECTION } from '../../../constants/form.constant';
import * as fromNetSheetActions from '../../../store/actions/net-sheet.actions';
import * as fromNetSheetSelectors from '../../../store/selectors/net-sheet.selectors';
import { GenericComponent } from '../../components/generic/generic.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-net-sheet',
  standalone: false,
  templateUrl: './net-sheet.page.html'
})
export class NetSheetPageComponent extends GenericComponent {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private store = inject(Store);

  private formSections = viewChildren(FORM_SECTION);

  profileId: string | null;

  constructor() {
    super();
    this.profileId = this.activatedRoute.snapshot.paramMap.get('id') ?? null;
    this.store.dispatch(fromNetSheetActions.loadInitialData());
  }

  resetFields() {
    this.store.dispatch(fromNetSheetActions.resetFields());
    this.store.dispatch(fromNetSheetActions.loadInitialData());
  }

  async calculate() {
    this.store.dispatch(fromNetSheetActions.calculate());

    this.addUniqueSubscription(
      'net-sheet-calculate',
      this.store
        .pipe(
          select(fromNetSheetSelectors.selectHasNetSheetCalculatorResult),
          filter((value) => value)
        )
        .subscribe({
          next: async () => {
            await this.router.navigate(['report'], { relativeTo: this.activatedRoute, skipLocationChange: true });
          }
        })
    );
  }

  readonly allSections = computed(() => [...this.formSections()]);
  readonly canCalculate = computed(() =>
    this.allSections().every((section) => {
      return section.valid();
    })
  );
}
